<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-card-title>
            <v-btn @click.stop="onAdd" color="primary" outline>
              <i class="material-icons">add</i>
              {{ $t("message.addNew") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              hide-details
              :label="$t('message.search')"
              single-line
              v-model="search"
            ></v-text-field>
          </v-card-title>

          <v-data-table :headers="headers" :items="items" :search="search">
            <template slot="headerCell" slot-scope="props">
              <span>{{ $t(`message.${props.header.text}`) }}</span>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.bank_name }}</td>
              <td>{{ props.item.account_type }}</td>
              <td>{{ props.item.account_number }}</td>
              <td>{{ props.item.owner_full_name }}</td>
              <td>{{ props.item.owner_document }}</td>
              <td class="text-left">
                <v-tooltip top>
                  <v-btn
                    @click="onEdit(props.item)"
                    color="primary"
                    outline
                    fab
                    icon
                    small
                    slot="activator"
                  >
                    <v-icon class="zmdi zmdi-edit"></v-icon>
                  </v-btn>
                  <span>{{ $t("message.edit") }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-btn
                    @click="onDelete(props.item)"
                    class="trash-icon"
                    color="error"
                    outline
                    fab
                    icon
                    slot="activator"
                    small
                  >
                    <v-icon light>cancel</v-icon>
                  </v-btn>
                  <span>{{ $t("message.delete") }}</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </app-card>
      </v-layout>
    </v-container>
    <account-modal
      :dialog.sync="showModal"
      ref="accountModal"
      :is-edit="!isCreate"
    ></account-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { GET_ACCOUNTS } from "../../../store/modules/accounts/actionTypes";
import AccountModal from "./AccountModal";
export default {
  data() {
    return {
      headers: [
        { text: "paymentMethod", sortable: true, value: "bank_name" },
        { text: "accountType", sortable: true, value: "account_type" },
        {
          text: "accountNumber",
          sortable: true,
          value: "account_number",
        },
        { text: "ownerName", sortable: true, value: "owner_full_name" },
        { text: "ownerDocument", sortable: true, value: "owner_document" },
        { text: "actions", sortable: false, value: "" },
      ],
      search: "",
      showModal: false,
      showModalImage: false,
      isCreate: true,
      selectedBank: {},
      ownerIdentificationType: {
        1: "V",
        2: "J",
        3: "R",
      },
    };
  },
  created() {
    this[GET_ACCOUNTS]();
  },
  computed: {
    ...mapGetters(["accounts"]),
    roleUser() {
      let userData = JSON.parse(localStorage.getItem("userData"));
      return userData.role_id;
    },
    items() {
      let accounts = [...this.accounts];
      this.generateDocumentationProp(accounts);
      return accounts;
    },
  },
  methods: {
    ...mapActions([GET_ACCOUNTS]),
    generateDocumentationProp(acc) {
      acc.forEach((item) => {
        item.owner_document =
          this.ownerIdentificationType[item.owner_identification_type] +
          "-" +
          item.owner_identification;
      });
    },
    onAdd() {
      this.showModal = true;
      this.isCreate = true;
    },
    onEdit(account) {
      this.$refs.accountModal.setValue(account);
      this.showModal = true;
      this.isCreate = false;
      // this.selectedBank = bank;
    },
    onDelete(item) {
      this.$store.dispatch('deleteAccount', item)
    }
  },
  components: {
    AccountModal,
  },
};
</script>